// Arrow for home page block buttons
const regionPageBlockButtons = document.querySelectorAll('.path-womeninhit .view-content-list .view-footer a');
// Add font-awesome arrow inside regionPageBlockButtons
if (regionPageBlockButtons.length > 0) {
  regionPageBlockButtons.forEach((button) => {
    // Check if the button already has an icon
    if (!button.querySelector('.fa-angles-right')) {
      const arrowIcon = document.createElement('i');
      arrowIcon.classList.add('fa-solid', 'fa-angles-right');
      button.appendChild(arrowIcon);
    }
  });
}